import $axios from "../../../api/accessories";
import { $api } from "../../../api/api";
import { getCookie } from "../../../api/utils/utils";
const guest_token = getCookie("bsc-guest-token-chat");

export class SupportProvider {
  static async getChatbotTemplate() {
    return await $axios.get($api("chatbot_template"));
  }
  static async getChildChatbotTemplate(id: number) {
    return await $axios.get($api("chatbot_template_id", { id }));
  }
  static async postUserChatData(payload: any) {
    return await $axios.post($api("post_user_data"), payload, {
      headers: {
        guest_token: guest_token || "",
      },
    });
  }
  static async sendMessage(id: number, payload: any) {
    return await $axios.post($api("send_message", {id}), payload, {
      headers: {
        guest_token: guest_token || "",
      },
    });
  }
}
